export const BOOTH_EDIT_STORE_NAME = 'boothEdit';
export const BOOTH_EDIT_ACTION_PREFIX = 'BOOTH_EDIT';
